import { type ApplePayDialogContext } from '@cart-services/hooks/useApplePayDialogActions'
import { DialogApplePayConfirm } from '@cart-ui/DialogApplePayConfirm/DialogApplePayConfirm'
import { type CountryCode } from '@constants'
import { type CheckoutPayApplePayModule } from '@payments'
import { useFpCampaignApplePayDialogFlow } from './useFpCampaignApplePayDialogFlow'

export interface CampaignApplePayDialogProps {
  context: ApplePayDialogContext
  paymentModule: CheckoutPayApplePayModule
  countryCode: CountryCode
  onClose: () => void
  onError?: (error: unknown) => void
  /** 確定要整頁導頁前呼叫，供 caller 切換全頁 loading。 */
  onRedirecting: () => void
}

export const CampaignApplePayDialog = ({
  context,
  paymentModule,
  countryCode,
  onClose,
  onError,
  onRedirecting,
}: CampaignApplePayDialogProps) => {
  const { mountApplePayButton, awaitAndExecutePayment, cancelInFlight } = useFpCampaignApplePayDialogFlow({
    paymentModule,
    countryCode,
    onRedirecting,
  })
  return (
    <DialogApplePayConfirm
      context={context}
      onClose={onClose}
      onError={onError}
      mountApplePayButton={mountApplePayButton}
      awaitAndExecutePayment={awaitAndExecutePayment}
      cancelInFlight={cancelInFlight}
    />
  )
}
